function getSubType (context) {
  const path = context.$route.path
  const expr = /\/scholarshippayments?\/([a-z]+).*/
  const subtype = expr.exec(path)[1]
  console.assert(subtype)
  return subtype
}

const filterParams = {
  planned: {planned: true},
  numbered: {numbered: true}
}
const overviewTitles = {
  planned: 'Planned Payments',
  numbered: 'Numbered Payments'
}
const detailTitles = {
  planned: 'Planned Payment',
  numbered: 'Numbered Payment'
}
const overviewRouterUrls = {
  planned: 'planned_scholarshippayments',
  numbered: 'numbered_scholarshippayments'
}
const detailRouterUrls = {
  planned: 'planned_scholarshippayment',
  numbered: 'numbered_scholarshippayment'
}

const fieldsMap = {
  planned:
  [
    {title: '', name: '__checkbox', titleClass: 'text-center', dataClass: 'text-center'},
    // {title: 'Invoice Number', name: 'number', sortField: 'number', link: '#/scholarshippayment/planned/{id}'},
    {title: 'Contract', name: 'contract', link: '#/contract/{contract_id}'},
    {title: 'Student', name: 'student_name'},
    {title: 'Type', name: 'scholarship_payment_type', sortField: 'scholarship_payment_type'},
    {title: 'Period', name: 'period', sortField: 'period'},
    {title: 'Amount', name: 'amount', sortField: 'amount', callback: 'formatMoney', dataClass: 'text-right'},
    {title: 'Planned', name: 'planned_date', sortField: 'planned_date', callback: 'formatDate'},
    {title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp'},
    // {title: 'Exported', name: 'exported_timestamp', sortField: 'exported_timestamp', callback: 'formatTimeStamp'},
    // {title: 'Payment', name: 'payment_timestamp', sortField: 'payment_timestamp', callback: 'formatTimeStamp'},
    {title: 'Comments', name: 'comments', sortField: 'comments'},
    {title: '', name: '__slot:actions', titleClass: 'text-center', dataClass: 'text-center'}
  ],
  numbered:
  [
    {title: '', name: '__checkbox', titleClass: 'text-center', dataClass: 'text-center'},
    {title: 'Number', name: 'number', sortField: 'number', link: '#/scholarshippayment/numbered/{id}'},
    {title: 'Contract', name: 'contract', link: '#/contract/{contract_id}'},
    {title: 'Student', name: 'student_name'},
    {title: 'Type', name: 'scholarship_payment_type', sortField: 'scholarship_payment_type'},
    {title: 'Period', name: 'period', sortField: 'period'},
    {title: 'Amount', name: 'amount', sortField: 'amount', callback: 'formatMoney', dataClass: 'text-right'},
    {title: 'Planned', name: 'planned_date', sortField: 'planned_date', callback: 'formatDate'},
    {title: 'Payment Date', name: 'payment_date', sortField: 'payment_date', callback: 'formatDate'},
    {title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp'},
    {title: 'Exported', name: 'exported_timestamp', sortField: 'exported_timestamp', callback: 'formatTimeStamp'},
    // {title: 'Payment', name: 'payment_timestamp', sortField: 'payment_timestamp', callback: 'formatTimeStamp'},
    {title: 'Export Allowed', name: 'payment_allowed', sortField: 'payment_allowed'},
    {title: 'Comments', name: 'comments', sortField: 'comments'},
    {title: '', name: '__slot:actions', titleClass: 'text-center', dataClass: 'text-center'}
  ]
}

export default {
  overviewApiUrl: '/scholarship_payments/',
  deleteTitle (context) { return detailTitles[getSubType(context)] },
  subType (context) { return getSubType(context) },
  overviewTitle (context) { return overviewTitles[getSubType(context)] },
  overviewRouterUrl (context) { return overviewRouterUrls[getSubType(context)] },
  getFilterName (context) { return overviewRouterUrls[getSubType(context)] },
  detailTitle (context) { return detailTitles[getSubType(context)] },
  updateNewRoute (context, route) { route.params.subtype = getSubType(context) },
  detailRouterUrl (context) { return detailRouterUrls[getSubType(context)] },
  updateNewRecord (context, rec) {
    // console.log('updateNewRecord', context.$route.params.subtype)
  },
  disableNew (context) { return getSubType(context) !== 'planned' },
  detailApiUrl: '/scholarship_payments/',
  quickFilterName: 'Number',
  quickFilterField: 'number',
  advancedSearch: true,
  sortOrder: [
    {
      field: 'number',
      sortField: 'number',
      direction: 'asc'
    }
  ],
  updateFilter (context, params) {
    const subparams = filterParams[getSubType(context)]
    console.assert(subparams)
    Object.assign(params, subparams)
  },
  fields (context) { return fieldsMap[getSubType(context)] }
}



// WEBPACK FOOTER //
// ./src/views/ScholarshipPayment/FieldDefs.js